"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsList = void 0;
var React = require("react");
var FieldsCategory_1 = require("./components/FieldsCategory");
var FieldsSubCategory_1 = require("./components/FieldsSubCategory");
var fieldsUtils_1 = require("./utils/fieldsUtils");
var FieldsGridContainer_1 = require("./components/FieldsGridContainer");
var Field_1 = require("./components/Field");
var FieldsList = function (props) {
    var _a = React.useState([]), nestedCategoryTrees = _a[0], setNestedCategorieyTrees = _a[1];
    React.useEffect(function () {
        var _a;
        if (((_a = props.fetchedReportFields) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setNestedCategorieyTrees((0, fieldsUtils_1.getNestedCategoryTrees)(props.fetchedReportFields));
        }
    }, [props.fetchedReportFields]);
    return (React.createElement("div", null, nestedCategoryTrees.map(function (nestedCategoryTree) { return (React.createElement(FieldsCategory_1.FieldsCategory, { key: nestedCategoryTree.categoryName, categoryName: nestedCategoryTree.categoryName },
        React.createElement(Field_1.SelectAllFields, { key: "SelectAll-".concat(nestedCategoryTree.categoryName), disabled: props.disabled, fields: __spreadArray(__spreadArray([], nestedCategoryTree.fields, true), nestedCategoryTree.subCategories.flatMap(function (subCategory) { return subCategory.fields; }), true), setSelectedFields: props.setSelectedFields, getSelectedFields: props.selectedFields }),
        React.createElement(FieldsGridContainer_1.FieldsGridContainerCategory, { nestedCategoryTree: nestedCategoryTree, selectedFields: props.selectedFields, setSelectedFields: props.setSelectedFields, disabled: props.disabled }),
        nestedCategoryTree.subCategories.map(function (nestedSubCategoryTree) { return (React.createElement(FieldsSubCategory_1.FieldsSubCategory, { key: nestedCategoryTree.categoryName +
                nestedSubCategoryTree.subCategoryName, subCategoryName: nestedSubCategoryTree.subCategoryName },
            React.createElement(FieldsGridContainer_1.FieldsGridContainerSubCategory, { nestedCategoryTreeName: nestedCategoryTree.categoryName, nestedSubCategoryTree: nestedSubCategoryTree, selectedFields: props.selectedFields, setSelectedFields: props.setSelectedFields, disabled: props.disabled }))); }))); })));
};
exports.FieldsList = FieldsList;
